<div class="flex-row flex__align-center">  
    <div  ssCoreLoaderOutlet
        class="flex-row full-stretch flex__align-center gap-standard" 
        [keys]="['activity.remove.'+this.activityId]"
        
    >
        <div *ngIf="showIdxObs | async" class="activity-idx mat-headline-6 margin-none"  >
            {{ activity.orderIndex + 1 }}
        </div>

        <ss-actor class="full-width" [suffixTemplate]="suffix"></ss-actor>

        <ng-template #suffix>
            <button type="button" mat-icon-button color="warn" (click)="removeActivity()">
            <mat-icon color="warn" >delete</mat-icon>
            </button>
        </ng-template>
    
    </div>

</div>
<p *ngIf="(showErrorObs | async)" class="warn-text" >{{'ss-process-wizard.actor-no-splugs' | translate}}</p>

      
  
